<template>
  <div class="logger-login-bd tb" v-if="funcView.log_login_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.log_login_export">
          <el-button class="table-set" @click.native="onExportTable()" :disabled="exporting">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right" :style="{ 'margin-right': !funcView.log_login_export ? 0 : '' }">
          <custom-column ref="column" :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('base_login.dlzhyhzhdlIP')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <!--  推送角色 -->

        <!-- 操作时间段，-->
        <el-form-item :label="$t('base_login.deng_lu_shi_jian')">
          <custom-date-picker
            v-model="formSearch.createTime"
            type="datetimerange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('base_login.tui_chu_shi_jian')">
          <custom-date-picker
            v-model="formSearch.offlineTime"
            type="datetimerange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <!-- 用户组织  -->
        <el-form-item :label="$t('base_login.yong_hu_zu_zhi')">
          <el-input v-model="formSearch.orgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <!-- 用户组织  -->
        <el-form-item :label="$t('base_login.zong_bu_ming_cheng')">
          <el-input v-model="formSearch.hqName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table v-loading="isLoading" index :data="loginLogList" :column="tableColumn" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>
<script>
// import moment from 'moment';
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'loggerLogin',
  mixins: [resetFormSearchMixins],
  components: {},
  data() {
    return {
      tableCode: 'loginLog',
      // translate: { i18n },
      pushConfigList: [],
      isLoading: false,
      // 分页
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        search: '',

        orgName: '',
        hqName: '',
        createTime: '',
        createTimeStart: '',
        createTimeEnd: '',
        offlineTime: '',
        offlineTimeStart: '',
        offlineTimeEnd: '',
      },
      // 日志列表
      loginLogList: [],
      totalRows: null,
      link: null,
      exporting: false,
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getloginLogList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    this.getTableColumn();
  },
  methods: {
    // 获取消息推送配置
    getloginLogList: function () {
      this.formSearch.createTimeStart = this.formSearch.createTime && this.formSearch.createTime[0] ? this.formSearch.createTime[0] : undefined;
      this.formSearch.createTimeEnd = this.formSearch.createTime && this.formSearch.createTime[1] ? this.formSearch.createTime[1] : undefined;
      this.formSearch.offlineTimeStart = this.formSearch.offlineTime && this.formSearch.offlineTime[0] ? this.formSearch.offlineTime[0] : undefined;
      this.formSearch.offlineTimeEnd = this.formSearch.offlineTime && this.formSearch.offlineTime[1] ? this.formSearch.offlineTime[1] : undefined;
      this.isLoading = true;
      this.$postJSON(apis.LoginLogPage, this.formSearch).then((res) => {
        this.isLoading = false;
        const recordsData = res.data.list;
        // recordsData.forEach((item) => {
        //   if (item.offlineTime) {
        //     const offlineTime = moment(item.offlineTime, 'YYYY-MM-DD HH:mm:ss');
        //     const onlineTime = moment(item.onlineTime, 'YYYY-MM-DD HH:mm:ss');
        //     const mintus = offlineTime.diff(onlineTime, 'minutes');
        //     item.onlineMinutes = mintus || '';
        //   }
        // });
        this.loginLogList = recordsData;
        this.totalRows = res.data.total;
      });
    },
    // clearFilter: function () {
    //   this.formSearch.orgName = '';
    //   this.formSearch.dataTimes = null; // 生效时间
    //   this.getloginLogList();
    // },
    onExportTable() {
      this.exporting = true;
      this.$exportFliePost(apis.loginLogExport, {
        ...this.formSearch,
        excelParam: {
          exportName: this.$t('base_login.deng_lu_ri_zhi_o', [this.$moment().format('YYYYMMDDHHmm')]),
          headerList: this.tableColumn,
        },
      })
        .then(() => {
          this.exporting = false;
        })
        .catch((e) => {
          this.$message.error(e.message || e.msg);
          this.exporting = false;
        });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getloginLogList();
    },
  },
};
</script>

<style lang="scss"></style>
